import BaseModel from "./BaseModel";

export default class FnbProduct extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.setData(data);
  }

  setData(data = this.__data__) {
    this.id = data.id || undefined;
    this.code = data.code || undefined;
    this.name = data.name || this.translate.name || undefined;
    this.shortName = data.shortName || this.translate.shortName || undefined;
    this.uom = data.uom || undefined;
    this.totalPrice = data.totalPrice || 0;
    this.isActive = data.isActive !== undefined ? data.isActive : true;

    // Related data (display only)
    this.menu = data.menu || "";
    this.condimentGroup = data.condimentGroup || "";
    this.optionGroup = data.optionGroup || "";

    // Editable fields
    this.description = data.description || this.translate.description || "";
    this.imageUrls = data.imageUrls || [];
    this.image = this.imageUrls[0] || ""; // Legacy support/helper for UI

    // Translations
    this.translations = data.translations || [];
  }

  export(hasTranslate = false) {
    const result = {
      id: this.id,
      code: this.code,
      name: this.name,
      shortName: this.shortName,
      uom: this.uom,
      description: this.description,
      imageUrls: this.imageUrls,
      isActive: this.isActive,
    };

    if (hasTranslate) {
      result.translate = () => {
        return {
          id: this.translate.id,
          fnbProductId: this.id,
          name: this.translate.name,
          shortName: this.translate.shortName,
          description: this.translate.description,
          languageCode: this.translate.languageCode,
        };
      };
    }

    return result;
  }
}
